//  Immediately Invoked Function Expression to keep the javascript Scope contained
(function() {

    angular
        .module('app')
        .directive('promoPack', promoPack);

    function promoPack() {
        return {
            restrict: 'E',
            controller: 'PromoPackController',
            controllerAs: 'vm',
            scope: {
                type: '<',
                download: '<',
                data: '='
            },
            bindToController: true
        };
    }

})();